const resourceTypeMixin = {
    data() {
        return {
            POSITION_RESOURCES:[1,2]
        }
    }
};

export default resourceTypeMixin;
